import { ofType } from 'redux-observable';
import {
  catchError,
  delay,
  map,
  switchMap,
  tap,
  withLatestFrom,
} from 'rxjs/operators';
import { EMPTY, from, of, concat, defer, timer } from 'rxjs';
import { httpMethods, request } from '../../../../../services/http-service';
import { UPSERT_DOCUMENTO_TIPO } from '../../data.const';
import {
  retrieveDocumentoTipoListAction,
  setLoaders,
  setPopupInfo,
} from '../../data.action';

const upsertDocumentoTipoEpic = (action$: any, state$: any) =>
  action$.pipe(
    ofType(UPSERT_DOCUMENTO_TIPO),
    map(({ payload }: any) => {
      const { createdAt, updatedAt, ...rest } = payload;
      if (rest.id === 'crea') {
        delete rest.id;
      }
      return rest;
    }),
    tap(p => console.log(`[epic ${UPSERT_DOCUMENTO_TIPO}]`, p)),
    withLatestFrom(state$),
    switchMap(([body, _state]) => {
      return concat(
        of(setLoaders({ anagraficaLoader: true, page: true })),
        defer(() =>
          from(
            request({
              path: `documentoTipo`,
              method: httpMethods.POST,
              body,
            })
          ).pipe(
            map((p: any) => {
              if (p?.status > 299) {
                throw new Error(p.message);
              }
              return p?.result;
            }),
            switchMap(data =>
              concat(
                of(retrieveDocumentoTipoListAction(null)),
                of(null).pipe(
                  switchMap(() =>
                    of(
                      setPopupInfo({
                        opened: true,
                        message: 'Operazione completata con successo',
                        timer: 3000,
                      })
                    )
                  )
                )
              )
            ),
            catchError(err => {
              console.error(`[epic ${UPSERT_DOCUMENTO_TIPO}] error`, err);
              return of(
                setPopupInfo({
                  opened: true,
                  message: 'Operazione non riuscita',
                  type: 'BAD',
                  timer: 3000,
                })
              );
            })
          )
        ),
        of(setLoaders({ anagraficaLoader: false, page: false }))
      );
    })
  );

export default upsertDocumentoTipoEpic;
